import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import apiClient from '../api/client';
import './Auth.css';

function Login2FA() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, password, redirect } = location.state || {};
  
  const [token, setToken] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token || token.length !== 6) {
      setError('Įveskite 6 skaitmenų kodą');
      return;
    }

    try {
      const res = await apiClient.post('/auth/login-with-2fa', {
        email,
        password,
        token: token.replace(/\D/g, '')
      });
      
      localStorage.setItem('token', res.data.token);
      const target = redirect && redirect.startsWith('/') ? redirect : '/';
      window.location.href = target;
    } catch (err) {
      setError(err.response?.data?.error || 'Neteisingas autentifikacijos kodas');
    }
  };

  if (!email || !password) {
    return (
      <div className="auth-page container">
        <div className="auth-card">
          <div className="error">Trūksta prisijungimo duomenų</div>
          <button onClick={() => navigate('/login')} className="btn btn-primary">
            Grįžti į prisijungimą
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page container">
      <div className="auth-card">
        <h1>Dvifaktorė autentifikacija</h1>
        
        <p style={{ textAlign: 'center', color: 'var(--color-gray-600)', marginBottom: 'var(--spacing-xl)' }}>
          Įveskite 6 skaitmenų kodą iš autentifikavimo programos
        </p>

        {error && <div className="error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={token}
            onChange={(e) => setToken(e.target.value.replace(/\D/g, '').slice(0, 6))}
            placeholder="000000"
            maxLength={6}
            required
            className="input"
            style={{
              textAlign: 'center',
              fontSize: '32px',
              letterSpacing: '12px',
              fontFamily: 'monospace',
              fontWeight: '600'
            }}
            autoFocus
          />
          
          <button type="submit" className="btn btn-primary btn-large">
            Patvirtinti
          </button>
        </form>

        <div style={{ marginTop: 'var(--spacing-xl)', textAlign: 'center' }}>
          <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-gray-600)' }}>
            Neturite prieigos prie autentifikavimo programos?<br />
            Naudokite backup kodą
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login2FA;
